const initialsFilter = (name) => {
    if (!name) return '--';

    const strippedName = name.replace(/[&/\\#,+()$~%.'":*?<>{}]/g, ''); // Filters out special characters
    let match = strippedName.match(/^\s*(\w)|\b(\w)(?=\S+$)/g); // Extracts the first letters from the first and last names of the customer to create initials
    if (!match) return '--';
    if (match.length > 2) match = match.slice(0, 2); // Deals with hyphenated names. Eg 'George Little-Fanningley' would be 'GLF' before this step, 'GL' after
    return match.join('').toUpperCase();
};

export default initialsFilter;
